import { useSite } from "@/context/SiteContext";
import { PageHero, SectionTitle } from "@/components/Shared";
import { IMAGES } from "@/lib/images";
import { ShieldCheck, Heart, Lock } from "lucide-react";

const VALORI = [
  { icon: Lock, title: "Discrezione", desc: "La privacy dei nostri soci è la nostra priorità assoluta." },
  { icon: Heart, title: "Rispetto & Consenso", desc: "Un ambiente fondato sul rispetto reciproco e sulla libertà di scelta." },
  { icon: ShieldCheck, title: "Solo Soci 18+", desc: "Circolo privato riservato esclusivamente a soci maggiorenni." },
];

export default function InfoStatuto() {
  const { settings } = useSite();
  return (
    <div>
      <PageHero
        overline="Chi Siamo"
        title="Statuto & Privacy"
        subtitle="Un circolo privato dedicato alla libertà, all'eleganza e alla discrezione."
        image={IMAGES.club_bar}
      />

      <section className="max-w-3xl mx-auto px-6 py-20">
        <SectionTitle overline="La Nostra Filosofia" title="Il Circolo Afrodite" />
        <p className="text-[#A39E9B] leading-relaxed text-center mb-14">
          {settings.about_text}
        </p>

        <div className="grid gap-5 sm:grid-cols-3 mb-20">
          {VALORI.map((v) => (
            <div key={v.title} className="text-center p-6 rounded-2xl border border-[#D4AF37]/12 bg-[#141217]">
              <div className="w-12 h-12 mx-auto rounded-full border border-[#D4AF37]/30 flex items-center justify-center mb-4">
                <v.icon className="w-5 h-5 text-[#D4AF37]" />
              </div>
              <h3 className="font-display text-lg text-[#FBF8F5] mb-2">{v.title}</h3>
              <p className="text-xs text-[#A39E9B] leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>

        <div className="space-y-8 text-sm text-[#A39E9B] leading-relaxed">
          <div>
            <h3 className="font-display text-xl text-[#FBF8F5] mb-3">Regolamento</h3>
            <p>L'accesso è riservato ai soli soci maggiorenni. Il tesseramento avviene direttamente presso la struttura. All'interno del circolo è richiesto un comportamento rispettoso verso persone e ambienti. È severamente vietato ogni comportamento non consensuale.</p>
          </div>
          <div>
            <h3 className="font-display text-xl text-[#FBF8F5] mb-3">Informativa Privacy (GDPR)</h3>
            <p>Questo sito utilizza esclusivamente cookie tecnici necessari al funzionamento. Non vengono raccolti dati personali a fini di profilazione. Le richieste di contatto avvengono tramite WhatsApp o telefono e i dati condivisi sono trattati con la massima riservatezza, nel rispetto del Regolamento UE 2016/679. Per qualsiasi richiesta relativa ai tuoi dati puoi contattarci ai recapiti indicati.</p>
          </div>
          <div>
            <h3 className="font-display text-xl text-[#FBF8F5] mb-3">Contatti</h3>
            <p>Telefono e WhatsApp: <span className="text-[#FBF8F5]">{settings.phone || "333 1512490"}</span><br />{settings.address}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
